import React, { useCallback } from 'react';

import { Box, Text, Stack, Select, TextField } from 'src/components/matchbox';
import { Heading } from 'src/components/text';
import { useAlertForm } from '../useAlertForm';

export default function Details() {
  const {
    state: { accountData, alertData },
    dispatch
  } = useAlertForm();

  const handleAlertNameChange = useCallback(
    (e) => {
      dispatch({ type: 'UPDATE_ALERT_DATA', data: { name: e.target.value } });
    },
    [dispatch]
  );

  return (
    <Stack>
      <Heading as="h4">Details</Heading>
      <Box display="flex">
        <Box mr="20px" width="60%" maxWidth="400px">
          <TextField
            label="Alert Name"
            placeholder="e.g. Block Rate > 20%"
            required
            value={alertData.name}
            onChange={handleAlertNameChange}
          />
        </Box>
        <Box>
          <Select
            label="Severity Level"
            options={[
              'None',
              {
                value: 'high',
                label: 'High'
              },
              {
                value: 'medium',
                label: 'Medium'
              },
              {
                value: 'low',
                label: 'Low'
              }
            ]}
          />
        </Box>
      </Box>
      <Box>
        <Text as="h5">Subaccount Assignment</Text>
        <Text>
          {accountData.assignment === 'subaccount' && accountData.subaccount.value !== undefined
            ? accountData.subaccount.value
            : 'Primary Account'}
        </Text>
      </Box>
    </Stack>
  );
}
